module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-04.21a46f1a.png";